import { render, staticRenderFns } from "./AliyunVideo.vue?vue&type=template&id=07b6ceb4&scoped=true&"
import script from "./AliyunVideo.vue?vue&type=script&lang=js&"
export * from "./AliyunVideo.vue?vue&type=script&lang=js&"
import style0 from "./AliyunVideo.vue?vue&type=style&index=0&id=07b6ceb4&prod&scoped=true&lang=less&"
import style1 from "./AliyunVideo.vue?vue&type=style&index=1&id=07b6ceb4&prod&lang=less&"
import style2 from "./AliyunVideo.vue?vue&type=style&index=2&id=07b6ceb4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6ceb4",
  null
  
)

export default component.exports